import React from 'react'
import './Header.css'

function header() {
    return (
        <div className="header">
            <img src="https://media.proprofs.com/images/QM/user_images/1753345/1739730101.gif" alt=""/>
        </div>
    )
}

export default header
